import React, { useEffect, useState} from "react";
import { use } from "react";

const ProfilePage = () => {
    const [userDetails, setUserDetails] = useState({
      name: '',
      email: '',
    });

    useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user'));
      if(user) {
        setUserDetails(user);
      }
    }, []);
  
    return (
      <div  style={{ textAlign: 'center', padding: '20px' }}>
        <h1>Profile</h1>
        <p><strong>Name:</strong> {userDetails.name}</p>
        <p><strong>Email:</strong> {userDetails.email}</p>
      </div>
    );
  };
  
  export default ProfilePage;